import { Component, OnInit, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ListPagerComponent } from '../list-pager/list-pager.component';
import { TableEmployeeTrainingProgramComponent } from '../table-employee-training-program/table-employee-training-program.component';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';

@Component({
    standalone: true,
    selector: 'card-employee-training-program',
    templateUrl: './card-employee-training-program.component.html',
    imports: [ CommonModule, TableEmployeeTrainingProgramComponent, ListPagerComponent, FormsModule ]
})
export class CardEmployeeTrainingProgramComponent implements OnInit {
    private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);

    @Input() pageSize: any | undefined;
    @Input() trainingProgramCode: any | undefined;

    vm: any = undefined;

    constructor() {
        this.vm = this;
    }

    ngOnInit() {
        this.vm.employees = [];
        this.vm.pageSize = 10;
        this.vm.trainingProgramCode = this.trainingProgramCode;
    }

    currentPageChanged(newPage) {
        this.vm.currentPage = newPage;
        this.angularBroadcastHelperService.rootBroadcast("loadMorePages", newPage);
    }
}
